
import React from "react"
import { createRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App.tsx";
import "./index.css";
import { installAuthInterceptor, startTokenAutoRefresh } from "./services/authSession";

installAuthInterceptor();
startTokenAutoRefresh();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
